<template>


  <section class="section-conten padding-y" style="min-height:84vh">
      <Loader :isLoading='Loading'/>



        <CenteredFigure
      class='centerImage'
      :Img='icAuth'
      />

      <div class='card-body'>
        <h4 v-show='!haveToken' class='card-title princing-card-title text-center'>Insira o código de verificação.</h4>
        <h4 v-show='haveToken' class='card-title princing-card-title text-center'>Aguarde...</h4>
        <ul class="list-unstyled  text-center">
 
            </ul>
      </div>

      <FooterContainer>

        <InputRedLight
        class='form-group'
        placeholder='Código de verificação'
        type="number"
        minLength=10
        maxLength=10
        title="Insira o código enviado por e-mail" 
        v-model='authCode'            
        />

        <Button
        id='first_button'
        Type='submit'
        Text='Inserir código.'
        :ButtonFunction='sendCode'
        />

        

    </FooterContainer>


  </section>



 
</template>

<script>
//import { mapActions } from 'vuex'
import Loader from '@/components/Load/LoadOverlay'
import CenteredFigure from '../../components/ImageStyle/CenteredFigure'
import InputRedLight from '../../components/Input/InputRedLight'
import FooterContainer from '../../components/Container/FooterContainer'
import Button from '../../components/Button/ButtonCallToAction'
import icAuth from '../../assets/img/icAuth.svg'


export default {
  data: () => ({
    user: '',
    Loading:false,
    icAuth:icAuth,
    haveToken:false,
    authCode:'',
  }),
  components: {
    Loader,
    CenteredFigure,
    InputRedLight,
    FooterContainer,
    Button,
  },
  
    async created () {
          console.log(this.$route.query.tk)
            if (this.$route.query.tk) {
                console.log('TK')
                this.haveToken = !this.haveToken
                this.Loading = !this.Loading
                const token = this.$route.query.tk
                token
                this.Loading = !this.Loading
                this.$router.push({ name: 'home'})
                
                
            }
     
  },
  methods: {
    async sendCode () {
      console.log(this.authCode, this.user)
    }
  }
}
</script>

<style>
.btn-red {
    color: #fff;
    background-color: var(--main-red);
    border-color:var(--main-red-black);
}

.btn-red :hover {
  color:var(--main-red-black);
}


</style>
